import React from "react";
import PublicInfoLayout from "./PublicInfoLayout";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Qué hace la app | Ahorra y respira",
  url: "https://ahorrayrespira.com/que-hace-la-app",
  description: "Qué puedes hacer con la app, qué no hace y para quién encaja mejor.",
  inLanguage: "es-ES",
};

export default function WhatAppDoesPage() {
  return (
    <PublicInfoLayout
      title="Qué hace la app"
      subtitle="Una explicación clara y sin tecnicismos de para qué sirve Ahorra y respira."
      updatedAt="18 de febrero de 2026"
      canonicalPath="/que-hace-la-app"
      structuredData={structuredData}
    >
      <section className="panel">
        <h2 className="panel-title">Qué puedes hacer exactamente</h2>
        <ul className="landing-list" style={{ marginTop: "0.5rem" }}>
          <li>Subir extractos de cuenta y tarjeta en CSV/XLSX.</li>
          <li>Categorizar movimientos de forma manual o con reglas automáticas.</li>
          <li>Ver análisis de ingresos, gastos y balance por año/categoría.</li>
          <li>Configurar un plan de ahorro y compararlo con tu gasto real.</li>
        </ul>
      </section>

      <section className="panel">
        <h2 className="panel-title">Qué NO hace (importante)</h2>
        <ul className="landing-list" style={{ marginTop: "0.5rem" }}>
          <li>No conecta directamente con tu banco.</li>
          <li>No mueve dinero ni ejecuta transferencias.</li>
        </ul>
      </section>

      <section className="panel">
        <h2 className="panel-title">Para quién encaja mejor</h2>
        <p>
          Para personas que quieren ordenar su economía doméstica sin depender de hojas Excel complejas y dedicando poco tiempo
          cada semana.
        </p>
      </section>
    </PublicInfoLayout>
  );
}
